import { render, staticRenderFns } from "./DefRegisterModal.Style#Drawer.vue?vue&type=template&id=18b2fae3&scoped=true&"
import script from "./DefRegisterModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./DefRegisterModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./DefRegisterModal.Style#Drawer.vue?vue&type=style&index=0&id=18b2fae3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2fae3",
  null
  
)

export default component.exports